export const pageHeaderHeight = 60;
export const videoWidth = 640;
export const videoHeight = 360;
export const padding = 10;
export const accentBorderWidth = 2;
export const timestampWidth = 80;
export const spacerHeight = 370;
export const fontSize = 16;
